import errors from './errors';
import listeners from './listeners';
import setup from './setup';

export default [
  setup,
  errors,
  listeners
];
